module.exports = __webpack_public_path__ + "static/media/outfit-paul-smith.7c9e3d05.jpg";